var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3169 16.8261C12.6179 16.0872 12.2729 15.2401 11.5462 14.934C10.8196 14.6279 9.98659 14.9788 9.6856 15.7177C9.38462 16.4566 9.72967 17.3038 10.4563 17.6099C11.1829 17.9159 12.016 17.5651 12.3169 16.8261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2031 13.3507C15.5863 12.8419 15.492 12.1091 14.9887 11.7194C13.9793 10.9343 12.7726 10.4777 11.4972 10.3992C9.80154 10.2974 8.16304 10.8732 6.89056 12.0218C6.41874 12.4493 6.37585 13.185 6.79619 13.6648C7.0221 13.9236 7.33664 14.0545 7.65119 14.0545C7.91998 14.0545 8.19163 13.9585 8.41182 13.7608C9.22678 13.0251 10.2762 12.6528 11.3628 12.7197C12.1806 12.7692 12.9527 13.06 13.599 13.563C14.1022 13.9556 14.82 13.8596 15.2031 13.3507Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.38 10.2792C18.8003 9.79939 18.7603 9.06659 18.2913 8.63622C16.304 6.82749 13.739 5.83008 11.0682 5.83008C8.3231 5.83008 5.70665 6.87402 3.69641 8.77289C3.23317 9.20908 3.20744 9.94478 3.63637 10.4159C3.86227 10.663 4.16823 10.7881 4.4742 10.7881C4.75157 10.7881 5.03181 10.6863 5.25199 10.4769C6.83615 8.97935 8.90358 8.15641 11.0682 8.15641C13.1757 8.15641 15.1974 8.94155 16.7672 10.3693C17.2362 10.7997 17.9568 10.7561 18.38 10.2792Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0685 1C7.06523 1 3.26208 2.5412 0.356822 5.33571C-0.100699 5.77771 -0.120716 6.51341 0.31107 6.98159C0.536971 7.22294 0.840079 7.34508 1.14319 7.34508C1.42628 7.34508 1.70937 7.24039 1.92955 7.02811C4.40874 4.64071 7.65429 3.32633 11.0685 3.32633C14.4199 3.32633 17.6197 4.59709 20.0817 6.90598C20.5449 7.34217 21.2684 7.31018 21.6973 6.8391C22.1263 6.36802 22.0948 5.62941 21.6316 5.19613C18.7463 2.48885 14.9946 1 11.0685 1Z",
    fill: "#F26829"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3785 4.54476L13.3905 4.47852V4.4112C13.3905 2.97551 12.3213 1.68066 10.8486 1.68066C9.3758 1.68066 8.30664 2.97551 8.30664 4.4112V4.47851L8.31862 4.54474L9.55912 11.4005C9.55912 11.4005 9.55912 11.4005 9.55912 11.4005C9.68386 12.09 10.2397 12.5166 10.8485 12.5166C11.4572 12.5166 12.013 12.09 12.1378 11.4006C12.1378 11.4005 12.1378 11.4005 12.1378 11.4005L13.3785 4.54476Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9276 17.3298C12.0869 17.3298 12.9021 16.3157 12.9021 15.2264C12.9021 14.1371 12.0869 13.123 10.9276 13.123C9.76827 13.123 8.95312 14.1371 8.95312 15.2264C8.95312 16.3157 9.76827 17.3298 10.9276 17.3298Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.cff6c7a4d7861632e982d692a27d896a.svg";
export { ForwardRef as ReactComponent };